
import permissionsMixin from './permissionsMixin'
import routerPermissionsSetup from './routerSetup'
import mapPermissions from './mapPermissions'

/**
 * Django Groups Permissions Integration
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 * @version 0.7
 */
export default {
  install(Vue) {
    Vue.use(permissionsMixin)
  }
}

export {
  routerPermissionsSetup,
  mapPermissions
}



// WEBPACK FOOTER //
// ./src/plugins/accountPermissions/index.js